import { getApps, initializeApp } from 'firebase/app'
import { firebaseConfig, isFirebaseConfigured } from '@core/config/firebase.js'

let firebaseApp = null

export function getFirebaseApp() {
  if (!isFirebaseConfigured()) {
    throw new Error('[Firebase] 配置不完整，请检查 .env 中的 VITE_FIREBASE_* 变量')
  }

  if (!firebaseApp) {
    firebaseApp = getApps().length ? getApps()[0] : initializeApp(firebaseConfig)
  }

  return firebaseApp
}
